import { Box, Button } from '@mui/material';

import {
  AbgDialog,
  AbgTypography,
  mergeSx,
  MinusFilledIcon,
} from '@abg/kit-base';
import { Loader } from '@abg/kit-base/lib/atoms/loader';
import { usePageContext } from '@abg/web-core/context/page/client-provider';

import { useAnalyticsGeneralEngagement } from '../../shared/analytics/hooks/use-analytics-general-engagement';

import { sessionExpiredModalStyles } from './SessionExpiredModal.styling';
import { SessionExpiredModalType } from './types';

export const SessionExpiredModal = ({
  isOpened,
  isLoading,
  onClickContinue,
  styleParts,
  t,
  texts,
}: SessionExpiredModalType) => {
  const { brand } = usePageContext();

  const { emitEvent: emitGeneralEngagementEvent } =
    useAnalyticsGeneralEngagement();
  return (
    <>
      <AbgDialog
        styles={{
          wrapper: sessionExpiredModalStyles.dialogWrapper,
          content: sessionExpiredModalStyles.content,
        }}
        isOpen={isOpened}
        divider={true}
        title={
          <Box sx={sessionExpiredModalStyles?.headerContainer}>
            <MinusFilledIcon />
            <AbgTypography
              sx={mergeSx(sessionExpiredModalStyles?.heading)}
              variant="bodyLargeBold"
              data-testid="rc-timeout-dialog-title"
            >
              {texts?.titleText || t('reservationCheckout.timer.popup.title')}
            </AbgTypography>
          </Box>
        }
        controls={
          <Box sx={sessionExpiredModalStyles?.buttonContainer}>
            {/* OOS for R1 */}
            {/* <Button
                  data-testid="rc-timeout-dialog-emailThisSearchButton-label"
                  sx={sessionExpiredModalStyles?.buttonGap}
                  variant={'outlined'}
                  className="secondary"
                  endIcon={
                    <AemImage
                      src={mailIcon}
                      alt="icon"
                      style={{ width: 12, height: 12 }}
                    />
                  }
                >
                  {t('reservationCheckout.timer.popup.emailThisSearchButton.label')}
                </Button> */}
            <Button
              variant={'outlined'}
              className="primary"
              onClick={(event) => {
                emitGeneralEngagementEvent(event.currentTarget);
                onClickContinue();
              }}
              data-testid="rc-timeout-dialog-continueButton-label"
            >
              {texts?.ctaText ||
                t('reservationCheckout.timer.popup.continueButton.label')}
            </Button>
          </Box>
        }
      >
        {isLoading && <Loader isActive brand={brand} />}

        <Box
          sx={mergeSx(
            styleParts?.timeOutDialogModal?.content,
            sessionExpiredModalStyles?.midContentContainer,
          )}
        >
          <AbgTypography
            sx={mergeSx(styleParts?.timeOutDialogModal?.content)}
            variant="body1"
            data-testid="rc-timeout-dialog-description"
          >
            {texts?.bodyText ||
              t('reservationCheckout.timer.popup.description')}
          </AbgTypography>
        </Box>
      </AbgDialog>
    </>
  );
};
